import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import { WarningPopUp, Image } from "hesus-ui-kit";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import activateIcon from "@icons/ic-activate.svg";
import copyIcon from "@icons/ic-copy.svg";
import { ActionButtons } from "../../CenterProductsList.styled";
import CopyCenterProduct from "../CopyCenterProduct/CopyCenterProduct";

const CenterProductAction = (props) => {
  const { t, data, onRefreshData, updateRefeshStatus, centerId, companyId } =
    props;
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isCopyVisible, setCopyVisible] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);

  const history = useNavigate();
  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState(
    "CONTACT_CONFIRMATION_BOX_DELETE"
  );
  const [confirmationBoxContent, setConfirmationBoxContent] = useState(
    "CONTACT_CONFIRMATION_BOX_DELETE_CONTENT"
  );

  const handleCenterProductStatus = (status) => {
    if (status === 1) {
      setConfirmationBoxTitle("CENTER_PRODUCT_CONFIRMATION_BOX_ENABLE");
      setConfirmationBoxContent(
        "CENTER_PRODUCT_CONFIRMATION_BOX_ENABLE_CONTENT"
      );
    } else {
      setConfirmationBoxTitle("CENTER_PRODUCT_CONFIRMATION_BOX_DELETE");
      setConfirmationBoxContent(
        "CENTER_PRODUCT_CONFIRMATION_BOX_DELETE_CONTENT"
      );
    }
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  const onProductEditClick = (productId) => {
    history(
      `/company/view/${companyId}/center/${centerId}/product/edit/${data.id}`
    );
  };

  useEffect(() => {
    if (isConfirm) {
      axios
        .post(
          `/companies/${companyId}/centres/${centerId}/products/${data.id}/updateStatus`,
          data.isActive === 1 ? `0` : 1
        )
        .then(() => {
          onRefreshData(true);
          setActionConfirmStatus(false);
        })
        .catch((error) => {
          onRefreshData(false);
          handleApiError(error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const copyCenterProduct = () => {
    setCopyVisible(true);
  };

  const onClose = () => {
    setCopyVisible(false);
  };

  return (
    <ActionButtons>
      {!!data.product.isActive && (
        <>
          {data.isActive === 1 && (
            <>
              <Image
                src={editIcon}
                onClick={onProductEditClick}
                alt={t("PRODUCT_ACTION_TOOLTIP_EDIT")}
                title={t("PRODUCT_ACTION_TOOLTIP_EDIT")}
                classname="center-products-list__image-icon-margin"
                styles={{ width: "25px", marginRight: "3px" }}
              />
              <Image
                src={copyIcon}
                title={t("PRODUCT_ACTION_TOOLTIP_COPY")}
                onClick={() => copyCenterProduct("copy")}
                alt={t("PRODUCT_ACTION_TOOLTIP_COPY")}
                classname="center-products-list__image-icon-margin"
                styles={{ width: "25px", marginRight: "3px" }}
              />
            </>
          )}
          {data.isActive === 1 && (
            <Image
              src={deleteIcon}
              onClick={() => handleCenterProductStatus(0)}
              alt={t("PRODUCT_ACTION_TOOLTIP_DISABLE")}
              title={t("PRODUCT_ACTION_TOOLTIP_DISABLE")}
              classname="center-products-list__image-icon-margin"
              styles={{ width: "25px" }}
            />
          )}
          {data.isActive !== 1 && (
            <Image
              src={activateIcon}
              onClick={() => handleCenterProductStatus(1)}
              alt={t("PRODUCT_ACTION_TOOLTIP_ACTIVATE")}
              title={t("PRODUCT_ACTION_TOOLTIP_ACTIVATE")}
              classname="center-products-list__image-icon-margin"
              styles={{ width: "25px" }}
            />
          )}
        </>
      )}
      {isConfirmVisible && (
        <WarningPopUp
          title={t(confirmationBoxTitle)}
          message={t(confirmationBoxContent)}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
      {isCopyVisible && (
        <CopyCenterProduct
          data={data}
          onClose={onClose}
          companyId={companyId}
          centerId={centerId}
        />
      )}
    </ActionButtons>
  );
};

CenterProductAction.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    canEdit: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
};
export default withTranslation()(CenterProductAction);
